import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import {Translation, Translator} from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import {
  ForEachModel,
  Model,
  useModelValue,
  useValue,
  ValueToCollection,
  WhenModelValue
} from '@morningtrain/react-resources'
import {StaticFilter} from '@morningtrain/react-filters'
import {EnvFilter} from 'support/filters'
import * as Displays from 'support/displays'
import {DurationFromSeconds} from 'support/displays'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import UserShiftLabel from 'ui/time-tracking/UserShiftLabel'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import SalaryBadge from '../../../../pages/app/hr/salary/SalaryBadge'

export default function UserShiftsSmartview() {
  const user = useValue('id')

  return (
        <Translator namespace='smartviews.user_shifts'>
            <Smartview>

                <SmartviewHeader>
                    <Translation name='title'/>
                </SmartviewHeader>

                <SmartviewContentSection>

                    <SmartviewTextGroup>
                        <Model resourceName='toggle.toggle' operationName='index'>
                            <EnvFilter name='from' envKey='salary.current_period.period_starts_at'/>
                            <EnvFilter name='to' envKey='salary.current_period.period_ends_at'/>
                            <StaticFilter name='user' value={user}/>
                            <ValueToCollection name='collection'>
                                <SmartviewContentSection>
                                    <ForEachModel>
                                        <SmartviewTextGroup>
                                            <SmartviewText label={<><UserShiftLabel/></>}>
                                                <ValueToCollection name='collection'>
                                                    <ForEachModel>
                                                        <div className='flex justify-between font-medium'>
                                        <span><Displays.Date
                                            name='started_at'
                                            dateFormat='dddd'
                                        />
                                          <WhenModelValue name='is_in_non_primary_department' condition={true}>
                                            <SalaryBadge>
                                              <Translation name='hr.salary.badges.has_been_lent_out' />
                                            </SalaryBadge>
                                          </WhenModelValue>
                                        </span>
                                                            <Displays.Time name='started_at' forceUTC/> - <Displays.Time
                                                            name='stopped_at' forceUTC/>
                                                        </div>
                                                        <div className='flex justify-between'>
                                        <span><Displays.Date
                                            name='started_at'
                                            dateFormat='DD. MMM YYYY'
                                        />
                                          </span>
                                                            <DurationFromSeconds name='duration_as_seconds'/>
                                                        </div>
                                                        <div className='flex justify-between'>
                                                            <Displays.Text name='location'/>
                                                        </div>
                                                    </ForEachModel>
                                                </ValueToCollection>
                                            </SmartviewText>
                                        </SmartviewTextGroup>
                                        <SmartviewContentSeparator/>
                                    </ForEachModel>
                                </SmartviewContentSection>
                            </ValueToCollection>
                        </Model>
                    </SmartviewTextGroup>

                </SmartviewContentSection>

            </Smartview>
        </Translator>
    )
}
